module.exports = __webpack_public_path__ + "img/6-1.6bd6e59e.jpg";